export const config = {
  url: {
    API_URL: process.env.REACT_APP_API_ENDPOINT,
    API_URL_UAPPLY: process.env.REACT_APP_API_ENDPOINT_UAPPLY,
  },
};
console.log("config", config);
// major test now lives in uapply-backend (ported /v1/majors) so authenticated
// submissions can link to the ulearn student — same route shape as before
export const SAVE_MAJOR = `${config.url.API_URL_UAPPLY}/majors/saveMajor`;
export const MAJOR = `${config.url.API_URL_UAPPLY}/majors`;

export const SEARCH_SUBJECT = `${config.url.API_URL_UAPPLY}/subjects/search`;
export const SEARCH_COUNTRY = `${config.url.API_URL_UAPPLY}/countries/search`;
export const LEADS = `${config.url.API_URL_UAPPLY}/leads`;
export const UNIVERSITIES = `${config.url.API_URL_UAPPLY}/universities`;
export const TEST_QUESTIONS = `${config.url.API_URL_UAPPLY}/testQuestions`;
export const APTITUDE_TEST = `${config.url.API_URL_UAPPLY}/aptitude-tests`;
export const IELTS_TESTS = `${config.url.API_URL_UAPPLY}/ielts-tests`;
export const IELTS_EVALUATE_WRITING = `${config.url.API_URL_UAPPLY}/ielts-tests/evaluate-writing`;
// Strict AI marker for the OBJECTIVE sections' open-ended (fill-blank / short-
// answer) items — same backend-proxied pattern as evaluate-writing, no keys in
// the bundle. Multiple-choice / true-false stay deterministic and never touch AI.
export const IELTS_EVALUATE_OBJECTIVE = `${config.url.API_URL_UAPPLY}/ielts-tests/evaluate-objective`;
export const ULEARN_STUDENTS = `${config.url.API_URL_UAPPLY}/ulearn-students`;
